import * as Sentry from "@sentry/react";
import type { DropZoneProps } from "react-aria-components";
import { DropZone as ReactAriaDropZone } from "react-aria-components";

interface IDropZone extends StrictOmit<DropZoneProps, "onDrop"> {
  ariaLabel: string;
  children: React.ReactNode;
  className?: string;
  onDrop: () => void;
}

export const DropZone = ({
  ariaLabel,
  children,
  className,
  isDisabled,
  onDrop,
}: IDropZone) => {
  return (
    <ReactAriaDropZone
      aria-label={ariaLabel}
      className={className}
      isDisabled={isDisabled}
      onDrop={(e) => {
        const allDroppedItems = e.items;
        allDroppedItems.forEach((droppedItem) => {
          if (droppedItem.kind !== "text") {
            Sentry.captureException(
              new Error("A dropped item did not have kind 'text'"),
            );
            return;
          }
          // 'medoma-item' marks a drag as one of ours, which is all it is read
          // for: what is being dragged is read from the drag and drop context.
          // Other options are available, see: https://react-spectrum.adobe.com/react-aria/useDraggableCollection.html#drag-data
          if (!droppedItem.types.has("medoma-item")) {
            Sentry.captureException(
              new Error("A dropped item was not of type 'medoma-item'"),
            );
            return;
          }

          onDrop();
        });
      }}
    >
      {children}
    </ReactAriaDropZone>
  );
};
